var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_home",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home_FILL0_wght300_GRAD-25_opsz20",
    d: "M188.759-777.6H191.8v-5.87h5.466v5.87h3.042v-8.683l-5.776-4.351-5.776,4.349Zm0,1.488a1.429,1.429,0,0,1-1.047-.439,1.431,1.431,0,0,1-.439-1.049v-8.683a1.474,1.474,0,0,1,.155-.667,1.357,1.357,0,0,1,.449-.515l5.78-4.354a1.5,1.5,0,0,1,.414-.214,1.456,1.456,0,0,1,.473-.079,1.4,1.4,0,0,1,.466.079,1.525,1.525,0,0,1,.408.214l5.78,4.354a1.357,1.357,0,0,1,.449.515,1.474,1.474,0,0,1,.155.667v8.683a1.431,1.431,0,0,1-.439,1.049,1.432,1.432,0,0,1-1.049.439h-4.53v-5.87h-2.491v5.87ZM194.534-784.131Z",
    transform: "translate(-165.534 882.114)",
    fill: "#8d8d8d"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.2465f1ca.svg";
export { ForwardRef as ReactComponent };